import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";

import Cookies from 'js-cookie'
import settings from '../../settings.json';

import Excel from './js/Excel.js';

import '../cm_parts/css/cm_list_body.css';
import './css/body.css';


export default class Body extends Component{
  state={
    order_info_array:[
      {"id":10001, "country":"us", "order_info":{"name":"Jony","address":"121 Calfornia", "email":"hello-us@gmail.com", "order_data":"2023-12-10 10:11", "status":"waitting_deposit", "ship_carrier":"", "ship_number":"", "updated_at":"2023-12-10 10:11"}, "sheet_id":"1aFjHO-KfUpcijCv2_K33hUNr57sxCdKg4ZvLPmGES_Q"},
      {"id":10002, "country":"in", "order_info":{"name":"usama","address":"121 Delhi", "email":"hello-india@gmail.com", "order_data":"2023-12-10 19:12", "status":"waitting_deposit", "ship_carrier":"", "ship_number":"", "updated_at":"2023-12-10 19:12"}, "sheet_id":"1w9gVHfTZGkNRxE8ND-f5wwn9miW5E7Yz1EfIKUbrwwk"}
    ],
    order_data_array:[
      {"id":10001, "order":[{"jan":"4900123456123","how":"5"}, {"jan":"4900123456123","how":"5"}]},
      {"id":10002, "order":[{"jan":"4900123456123","how":"5"}, {"jan":"4900123456123","how":"25"}]}
    ],

    show_sheet:false,
    google_sheet_id:'',
    show_order_data:false,
    show_add_order:false
  }
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount () {

  }
  

  handleChange = (e) => {
    console.dir(e);
  }
  
  
  
  render(){



    var openGoogleSheet = async (e) => {
      console.dir(e.target.id);
      this.setState({google_sheet_id:e.target.id});
      this.setState({show_sheet:true});
    }

    var closeIframe = async (e) => {
      this.setState({show_sheet:false});
    }


    var openOrderdata = async (e) => {
      console.dir(e.target.id);
      this.setState({show_order_data:true});
    }

    var closeOrderData = async (e) => {
      console.log('clicked');
      this.setState({show_order_data:false});
    }

    var addOrder = async (e) => {
      this.setState({show_add_order:true});
    }

    var closeAddOrder = async (e) => {
      this.setState({show_add_order:false});
    }

    return (
      <main className="my-3">
        <div>
          <table className="order-table">
            <thead>
              <td>ステータス</td>
              <td>管理番号</td>
              <td>国</td>
              <td>注文者名</td>
              <td>注文情報＆着荷状況</td>
              <td>キャリア</td>
              <td>更新日</td>
            </thead>
            <tbody>
              {this.state.order_info_array.map((data, index)=>{

                return(
                  <tr key={data.id}>
                    <td>{data.order_info.status}</td>
                    <td>{data.id}</td>
                    <td>{data.country}</td>
                    <td>
                      {data.order_info.name}
                      <Button variant="outline-secondary" id={"edit-"+String(data.id)} size="sm" className="mx-1" onClick={event=>openOrderdata(event)} ><i class="bi bi-pencil-fill"></i></Button>
                    </td>
                    <td>
                      {/*
                      <OrderItemList

                      />
                      */}

                      <Button variant="outline-secondary" id={data.sheet_id} size="sm" className="mx-1" onClick={event=>openGoogleSheet(event)} >詳細</Button>


                    </td>
                    {/*
                    <td>
                      <LogiJanList
                      
                      />
                    </td>
                     */}
                    <td>{data.ship_carrier}<br/>{data.ship_number}</td>
                    <td>{data.order_info.updated_at}</td>
                  </tr>

  
                )


              })}

            </tbody>
          </table>
          
          <div className="add-data-button" onClick={event=>addOrder(event)}><i class="bi bi-plus-circle"></i></div>

        </div>

        <div>


          
        </div>







        {this.state.show_sheet ?
          <>
            <div className="form-control-select add-teigi-table-form ifram-body">

              <iframe width="800" height="600" src={"https://docs.google.com/spreadsheets/d/"+this.state.google_sheet_id+"/edit?usp=sharing?gid=0&amp;single=true&amp;widget=true&amp;range=A1%3AE500"}></iframe>

              <div className="jan-info-close-button" onClick={event=>closeIframe(event)}><i className="bi bi-x-circle"></i></div>

            </div>
          </>
          :
          <></>
        }



        {this.state.show_order_data ?
          <>
            <div className="form-control-select add-teigi-table-form ifram-body">

              <Excel 
              
              
              />    

              <div className="jan-info-close-button" onClick={event=>closeOrderData(event)}><i className="bi bi-x-circle"></i></div>

            </div>
          </>
          :
          <></>
        }





        {this.state.show_add_order ?
          <>
            <div className="show-add-order">
              注文情報を追加
              <Button variant="primary" id="" size="sm" >追加する</Button>
              
              <Excel 
              
              
              />    

              <div className="jan-info-close-button" onClick={event=>closeAddOrder(event)}><i className="bi bi-x-circle"></i></div>

              
              <small>追加ボタン押して、入金済めば、無在庫発注のチャットワークにエクセル添付して、通知する</small>
            </div>
          </>
          :
          <></>
        }



      </main>
      
    );
  }
}











{/*
課題
APIでGoogleSheetコピー
閲覧権限をOPENに
https://issuetracker.google.com/issues/69238694?pli=1
https://developers.google.com/apps-script/concepts/scopes?hl=ja
https://developers.google.com/apps-script/guides/client-verification?hl=ja

ダメだった　https://stackoverflow.com/questions/47675320/google-sheets-onedit-you-do-not-have-permission-to-call-a-service

SAMPLE<iframe width="800" height="600" src="https://docs.google.com/spreadsheets/d/1w9gVHfTZGkNRxE8ND-f5wwn9miW5E7Yz1EfIKUbrwwk/edit?usp=sharing?gid=0&amp;single=true&amp;widget=true&amp;range=A1%3AE500"></iframe>

*/}